import { render, staticRenderFns } from "./PaletteChip.vue?vue&type=template&id=718657d1&scoped=true"
import script from "./PaletteChip.vue?vue&type=script&lang=js"
export * from "./PaletteChip.vue?vue&type=script&lang=js"
import style0 from "./PaletteChip.vue?vue&type=style&index=0&id=718657d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718657d1",
  null
  
)

export default component.exports